import { isObject } from "@next-core/utils/general";
import { setupTemplateProxy } from "./setupTemplateProxy.js";
import { childrenToSlots } from "../Renderer.js";
import { replaceSlotWithSlottedBricks } from "./replaceSlotWithSlottedBricks.js";
export function setupUseBrickInTemplate(props, hostContext) {
  function walk(props) {
    if (!isObject(props) || typeof props === "function") {
      return props;
    }
    if (Array.isArray(props)) {
      return props.map(walk);
    }
    return Object.fromEntries(Object.entries(props).map(_ref => {
      let [key, value] = _ref;
      return isObject(value) && key === "useBrick" ? Array.isArray(value) ? [key, value.flatMap(v => setup(v))] : [key, setup(value)] : [key, walk(value)];
    }).concat(Object.getOwnPropertySymbols(props).map(k => [k, props[k]])));
  }
  function setup(item, markSlotted) {
    if (item.brick === "slot") {
      markSlotted === null || markSlotted === void 0 || markSlotted();
      return replaceSlotWithSlottedBricks(item, hostContext, it => setup(it));
    }
    const {
      properties,
      slots: originalSlots,
      children,
      ...restConf
    } = item;
    const transpiledSlots = childrenToSlots(children, originalSlots);
    let slotted = false;
    const markChild = () => {
      slotted = true;
    };
    const slots = Object.fromEntries(Object.entries(transpiledSlots !== null && transpiledSlots !== void 0 ? transpiledSlots : {}).map(_ref2 => {
      var _slotConf$bricks;
      let [slotName, slotConf] = _ref2;
      return [slotName, {
        type: "bricks",
        bricks: ((_slotConf$bricks = slotConf.bricks) !== null && _slotConf$bricks !== void 0 ? _slotConf$bricks : []).flatMap(it => setup(it, markChild))
      }];
    }));
    return {
      ...restConf,
      properties: walk(properties),
      slots,
      ...setupTemplateProxy(hostContext, restConf.ref, slots, slotted)
    };
  }
  return walk(props);
}
//# sourceMappingURL=setupUseBrickInTemplate.js.map